import {RequestDetail} from '../../../models/requestDetail';
import { IController } from 'angular';

export class DetailController implements IController {
    static $inject = ['$mdMedia'];

    constructor(private _$mdMedia: angular.material.IMedia) {
    
    }

    $onInit() { }

    requestDetail: RequestDetail;
    
    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    ischargeToConsigneeEnabled(chargeToConsigneee : string): boolean {
        return (chargeToConsigneee === "Yes");       
    }

    isOtherLocationExist(location: string): boolean {
        return (location === "Other");
    }

    isConsigneeParameterHasValue(consigneeeParameter: string): boolean {
        return (consigneeeParameter !== undefined && consigneeeParameter !== null && consigneeeParameter.length > 0);
    }

    isParameterHasValue(parameter: string): boolean {
        return (parameter !== undefined && parameter !== null && parameter.length > 0);
    }

    getTransportModeIcon(transportModeVal: string): string {
        if (!transportModeVal)
            return '';

        if (transportModeVal.toUpperCase().toString().trim() === 'LTL')
            return 'airport_shuttle';
        else if (transportModeVal.toUpperCase().toString().trim() === 'TRUCK')
            return 'local_shipping';
        else if (transportModeVal.toUpperCase().toString().trim() === 'OCEAN')
            return 'directions_boat';
        else if (transportModeVal.toUpperCase().toString().trim() === 'AIR')
            return 'flight';
        else if (transportModeVal.toUpperCase().toString().trim() === 'EXPRESS')
            return 'star';
        else if (transportModeVal.toUpperCase().toString().trim() === 'EXPRESS OR LTL')
            return 'star';
        return '';
    }

 }


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/directives/detail/controllers/detailController.ts
 **/